/* Opuliss Journal modules: carousel (left/right arrows, dots, swipe) + scroll reveal.
   Vanilla, no dependencies. Idempotent (safe to call more than once). */
(function () {
  function initCarousel(root) {
    if (root.dataset.ojrCarouselReady) return;
    root.dataset.ojrCarouselReady = "1";
    var track = root.querySelector(".ojr-carousel__track");
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    if (!slides.length) return;
    var prev = root.querySelector(".ojr-carousel__arrow--prev");
    var next = root.querySelector(".ojr-carousel__arrow--next");
    var dotsWrap = root.querySelector(".ojr-carousel__dots");
    var dots = [];
    var idx = 0;

    if (dotsWrap) {
      slides.forEach(function (_, i) {
        var d = document.createElement("button");
        d.type = "button";
        d.className = "ojr-carousel__dot";
        d.setAttribute("aria-label", "Go to slide " + (i + 1));
        d.addEventListener("click", function () { go(i); });
        dotsWrap.appendChild(d);
        dots.push(d);
      });
    }

    function go(i) {
      idx = Math.max(0, Math.min(slides.length - 1, i));
      var slideW = slides[0].getBoundingClientRect().width;
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap || "0") || 0;
      track.style.transform = "translateX(" + (-(slideW + gap) * idx) + "px)";
      if (prev) prev.disabled = idx === 0;
      if (next) next.disabled = idx === slides.length - 1;
      dots.forEach(function (d, j) { d.classList.toggle("is-active", j === idx); });
    }

    if (prev) prev.addEventListener("click", function () { go(idx - 1); });
    if (next) next.addEventListener("click", function () { go(idx + 1); });
    var rt;
    window.addEventListener("resize", function () { clearTimeout(rt); rt = setTimeout(function () { go(idx); }, 150); });

    var sx = 0;
    track.addEventListener("touchstart", function (e) { sx = e.touches[0].clientX; }, { passive: true });
    track.addEventListener("touchend", function (e) {
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 40) go(idx + (dx < 0 ? 1 : -1));
    }, { passive: true });

    go(0);
  }

  function initReveal() {
    var els = document.querySelectorAll(".ojr-reveal:not(.is-in)");
    if (!els.length) return;
    if (!("IntersectionObserver" in window)) {
      Array.prototype.forEach.call(els, function (e) { e.classList.add("is-in"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add("is-in"); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -7% 0px" });
    Array.prototype.forEach.call(els, function (e) { io.observe(e); });
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll("[data-ojr-carousel]"), initCarousel);
    initReveal();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
  // Re-run shortly after load for late-injected content (Shopify sections, etc.)
  window.addEventListener("load", function () { setTimeout(initAll, 200); });
  window.OpulissJournalModules = { init: initAll };
})();
